import { Flex } from "features/comments/modals/comment-center.style";
import Personas from "features/grid-table/columns-components/Personas";
import { useHistory } from "react-router-dom";
import { IconDispatcher } from "shared/Icons";
import styled from "styled-components";
import { EMPTY_GUID, getTimeSince } from "utils/helpers";
import { useTranslation } from "react-i18next";

interface RecentWorkCardProps {
	recordId: string;
	entityName: string;
	name: string;
	createdOn: string;
	isSample: boolean;
	relatedItems: any;
}

export const RecentWorkCard: React.FC<RecentWorkCardProps> = ({ recordId, entityName, name, createdOn, isSample = false, relatedItems }) => {
	const history = useHistory();
	const { t } = useTranslation();

	const getEntityData = (entityName: string) => {
		const data: { defaultName?: string; icon?: string; redirect?: () => void; renderRelatedItems?: () => void } = {};
		switch (entityName) {
			case "cem_cxprogram":
				data["defaultName"] = "NEW_CX_PROGRAM";
				data["icon"] = "CX-PROGRAM";
				data["redirect"] = () => history.push(`/EditCxProgram?programid=${recordId}`);
				break;
			case "cem_customerjourney":
				data["defaultName"] = "ASPX_125";
				data["icon"] = "CJM";
				data["redirect"] = () => history.push(`/EditMap?cjmid=${recordId}&personaId=${relatedItems[0]?.recordId || EMPTY_GUID}&origin=1`);
				data["renderRelatedItems"] = ({ relatedItems }: any) => {
					const linkedPersonas: string[] = [];
					relatedItems?.forEach((relatedItem) => linkedPersonas.push(relatedItem.recordId));
					return Personas({ linkedPersonas }, 1, 28);
				};
				break;
			case "cem_persona":
				data["defaultName"] = "JS_82";
				data["icon"] = "PERSONA";
				data["redirect"] = () => history.push(`/EditPersona?personaIdStr=${recordId}`);
				break;
			case "cem_insight":
				data["defaultName"] = "NEW_INSIGHT_NAME";
				data["icon"] = "GEM";
				data["redirect"] = () => history.push(`/insights?id=${recordId}`);
				break;
			case "cem_cxopportunity":
				data["defaultName"] = "NEW_OPPORTUNITY_NAME";
				data["icon"] = "OPPORTUNITY";
				data["redirect"] = () => history.push(`/opportunity?id=${recordId}`);
				break;
			case "cem_cxsolution":
				data["defaultName"] = "NEW_SOLUTION_NAME";
				data["icon"] = "SOLUTION";
				data["redirect"] = () => history.push(`/solutions?id=${recordId}`);
				break;
			case "cem_cxactiontask":
				data["defaultName"] = "NEW_CX_ACTION_NAME";
				data["icon"] = "MENU-ACTION";
				data["redirect"] = () => history.push(`/cx-actions?id=${recordId}`);
				break;
			case "cem_cxproject":
				data["defaultName"] = "NEW_PROJECT";
				data["icon"] = "PROJECT";
				data["redirect"] = () => history.push(`/EditProject?id=${recordId}`);
				break;
		}
		return data;
	};
	const { redirect, icon, renderRelatedItems, defaultName } = getEntityData(entityName) || {};
	return (
		<Card background={isSample ? "#f8fafc" : "#FFF"} onClick={redirect}>
			<Flex vertical gap={16}>
				<IconContainer>{IconDispatcher(icon)}</IconContainer>
				<Title>{name || t(defaultName)}</Title>
			</Flex>
			{renderRelatedItems && renderRelatedItems({ relatedItems })}
			<Time>{getTimeSince({ createdOn })}</Time>
		</Card>
	);
};

const Card = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 218px;
	height: 220px;
	padding: 16px;
	border-radius: 8px;
	border: 1px solid #d9d9d9;
	background: ${({ background }: any) => background};
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
	:hover {
		cursor: pointer;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
	}
`;

const Title = styled.div`
	height: 64px;
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
`;

const Time = styled.div`
	color: #595959;
	font-family: "Inter";
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 18px */
	justify-self: end;
`;

const IconContainer = styled.div`
	width: 32px;
	height: 32px;
	svg {
		width: 32px;
		height: 32px;
	}
`;
